<mat-slide-toggle
  class="m-b-16 d-block"
  [checked]="isLogoVisible"
  (change)="onLogoVisibilityChange($event)"
  >
  Show Dashboard Logo
</mat-slide-toggle>

@if (shouldShowKeywordsSection) {
  <div class="keywords-section m-b-24">
    <h3 class="m-b-16">Dashboard Keywords</h3>
    <p class="m-b-16 text-muted">
      Select up to 4 keywords to display as quick actions in the conversation input ({{
      selectedKeywords.length
      }}/4 selected)
    </p>
    @if (isKeywordsLoading) {
      <div class="keywords-loading">
        <mat-spinner diameter="24"></mat-spinner>
        <span class="m-l-8">Loading keywords...</span>
      </div>
    }
    @if (!isKeywordsLoading && availableKeywords.length > 0) {
      <div class="keywords-grid">
        @for (keyword of availableKeywords; track keyword) {
          <div
            class="keyword-item"
            [class.selected]="isKeywordSelected(keyword)"
            [class.disabled]="!canSelectMoreKeywords() && !isKeywordSelected(keyword)"
            (click)="toggleKeyword(keyword)"
            >
            <span class="keyword-text">{{ keyword.keyword }}</span>
            <span class="keyword-count">({{ keyword.folderCount }})</span>
            @if (isKeywordSelected(keyword)) {
              <mat-icon class="selected-icon">check_circle</mat-icon>
            }
          </div>
        }
      </div>
    }
    @if (!isKeywordsLoading && availableKeywords.length === 0) {
      <div class="no-keywords">
        <mat-icon>info_outline</mat-icon>
        <div class="no-keywords-content">
          <span class="no-keywords-title">Keywords feature temporarily unavailable</span>
          <p class="no-keywords-description">
            The keywords endpoint is not available on the backend yet. Once implemented, you'll be able
            to select up to 4 keywords for quick access in the conversation input.
          </p>
          <p class="no-keywords-dev-note">
            <strong>For developers:</strong> You can test this feature by setting
            <code>USE_MOCK_DATA = true</code> in the KeywordsService.
          </p>
        </div>
      </div>
    }
    @if (selectedKeywords.length > 0) {
      <div class="selected-keywords-preview">
        <h4 class="m-b-8">Selected Keywords Preview:</h4>
        <div class="selected-keywords-list">
          @for (keyword of selectedKeywords; track keyword) {
            <div class="selected-keyword-chip">
              <span>{{ keyword.displayText }}</span>
              <mat-icon (click)="toggleKeyword({ keyword: keyword.keyword, folders: [], folderCount: 0 })"
                >close</mat-icon
                >
              </div>
            }
          </div>
        </div>
      }
    </div>
  }

  <quill-editor
    placeholder="Enter text here..."
    [(ngModel)]="htmlContent"
    [modules]="quillModules"
    [styles]="{ height: '300px' }"
  ></quill-editor>
  <button mat-raised-button class="m-t-16 control" color="accent" (click)="save()">Save</button>
